export default "__VITE_ASSET__C88w1aCY__"